var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLandingLine1300 = function SvgLandingLine1300(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 551,
    height: 1699,
    fill: "none",
    className: "landing-line-1300_svg__landing-line-1300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3,
    d: "M490 .5v14.766c0 60.35-41.841 112.634-100.723 125.863l-94.554 21.242C235.841 175.6 194 227.884 194 288.234v96.247c0 63.385 46.049 117.379 108.64 127.383l136.22 21.772c62.59 10.004 108.64 63.998 108.64 127.383v57.258c0 68.948-54.218 125.708-123.094 128.864l-299.312 13.718C56.218 864.015 2 920.775 2 989.723v58.217c0 70.88 57.183 128.48 128.058 129l291.384 2.12c70.875.52 128.058 58.12 128.058 129v45.44c0 73.27-54.247 135.23-126.879 144.91l-70.097 9.34c-95.613 12.74-167.024 94.29-167.024 190.75"
  })));
};
export default SvgLandingLine1300;